import { useState } from 'react';
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { Button, Card, Carousel, Container } from 'react-bootstrap';
import SimpleReactLightbox from "simple-react-lightbox";
import InnerPageLayout from "../../Components/Layout/InnerPageLayout";
import { getSingleImageGallery } from "../../api/api";
import { ImageData } from "../../types/news";
import styled from "styled-components";

const SingleGallery = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const [index, setIndex] = useState(0);

  const { isLoading, error, data }: any = useQuery(
    "SingleImageGalleryData",
    () => getSingleImageGallery({ id: id || "1", language: "en" })
  );

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  if (!data) return <div>No data found</div>;

  console.log(data)

  const handleSelect = (selectedIndex: number) => {
    setIndex(selectedIndex);
  };

  return (
    <InnerPageLayout>
       <Card className="mb-4">
       <Card.Header>{t('photo_album')}</Card.Header>
    
      <Card.Body>

        
      <SimpleReactLightbox>
        <StyledContainer>
          <CarouselWrapper>
            <StyledCarousel activeIndex={index} onSelect={handleSelect}>
              {data.data.attributes.images.data.map(( v: ImageData, idx: number) => (
                <Carousel.Item key={idx}>
                  <img
                    className="d-block w-100"
                    src={`${process.env.REACT_APP_CMS}${v?.attributes?.url ?? ''}`}
                    alt={`Slide ${idx}`}
                  />
                </Carousel.Item>
              ))}
            </StyledCarousel>
            <CarouselIndicatorsWrapper>
              {data.data.attributes.images.data.map((item: ImageData, idx: number) => (
                <ThumbnailButton
                  key={idx}
                  style={{ backgroundImage: `url(${process.env.REACT_APP_CMS}${item.attributes.url})` }}
                  className={idx === index ? 'active' : ''}
                  onClick={() => setIndex(idx)}
                />
              ))}
            </CarouselIndicatorsWrapper>
          </CarouselWrapper>
        </StyledContainer>
      </SimpleReactLightbox>

      </Card.Body>

      <Card.Footer className="text-center">
        <Link to="/gallery">
          <Button variant="primary">عودة الى ألبوم الصور</Button>
        </Link>
      </Card.Footer>
    </Card>
    </InnerPageLayout>
  );
};

const StyledContainer = styled(Container)`
  margin: 40px;
`;

const CarouselWrapper = styled.div`
  max-width: 800px;
  margin: auto;
`;

const StyledCarousel = styled(Carousel)`
  .carousel-item img {
    height: 500px;
    object-fit: cover;
  }
`;

const CarouselIndicatorsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const ThumbnailButton = styled.button`
  background-size: cover;
  border: none;
  width: 100px;
  height: 60px;
  margin: 0 5px;
  cursor: pointer;
`;

export default SingleGallery;
